import React, { FC, ReactNode } from 'react';
import { Grid, makeStyles, Theme, Typography } from '@material-ui/core';

export interface DescriptionItemProps {
  svgIcon: ReactNode;
  title: string;
  text: string;
  animationDelay: number;
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    imageIcon: {
      marginBottom: theme.spacing(2),
      display: 'inline-flex',
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(5),
      },
    },
    title: {
      fontWeight: 500,
      textTransform: 'uppercase',
      marginBottom: theme.spacing(1),
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(4),
      },
    },
  };
});

const DescriptionItem: FC<DescriptionItemProps> = ({ svgIcon, text, title, animationDelay }) => {
  const classes = useStyles();
  return (
    <div data-aos="fade-up" data-aos-delay={animationDelay}>
      <Grid className={classes.imageIcon} item>
        {svgIcon}
      </Grid>
      <Typography className={classes.title} variant="h2" color={'textPrimary'}>
        {title}
      </Typography>
      <Typography color={'textPrimary'}>{text}</Typography>
    </div>
  );
};

export default DescriptionItem;
